<script src="https://map.qq.com/api/gljs?v=1.exp&key=H4ABZ-NLZ33-VMI3Y-YE7WF-RIB45-KYB2M"></script>
<style scoped>
    #container {
        /*地图(容器)显示大小*/
        width: 100%;
        height: 100%;
    }

    .search {
        width: 800px;
        max-width: 60%;
        height: 45px;
        background: #fff;
        border: none;
        position: fixed;
        top: 44px;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 9999;
        border-radius: 10px;
        text-align: center;
        box-shadow: 0 0 10px 0px #8f8f8f85;
        outline: none;
    }

    .search:focus {
        border: none;
    }

    .info_box {
        padding-top: 52px;
        font-size: 14px;
    }

    .title {
        position: absolute;
        right: 0;
        background: #fff;
        box-shadow: 0 1px 0px 0px #e7e7e7;
        padding: 0 15px;
        top: 0;
        left: 0;
        line-height: 20px;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 2;
    }

    .item_box {
        height: calc(100% - 82px);
        overflow-y: auto;
        padding: 15px;
        border-bottom: 1px solid #f2f2f2;
        position: relative;
    }

    .info_box .item {
        /* line-height: 40px; */
        margin-bottom: 20px;
        display: flex;
        flex-wrap: wrap;
    }

    .info_box .item>span:nth-child(1) {
        width: 100px;
        display: block;
    }

    .info_box .item>span:nth-child(2) {
        width: calc(100% - 120px);
        display: block;
        margin-left: 20px;
    }

    .unit_type {
        margin-right: 20px;
    }

    .status_img {
        width: 30px;
        vertical-align: middle;
    }

    .zj {
        width: 180px;
        margin-right: 15px;
    }

    .pic {
        width: 180px;
        margin-right: 15px;
        margin-bottom: 10px;
    }

    .close {
        width: 24px;
        height: 24px;
        cursor: pointer;
    }

    .close:hover {
        transform: rotate(360deg);
        transition: 1s;
    }

    .contract_img {
        width: 100px;
        margin-right: 10px;
        margin-bottom: 10px;
    }

    .access_img {
        width: 150px;
        margin-right: 10px;
        margin-bottom: 10px;
        background: #bbb;
    }

    .sign_img {
        width: 160px;
        position: absolute;
        right: 15px;
    }

    .echarts_zxt {
        width: 100%;
        height: 400px;
        margin-top: 40px;
    }

    .bar {
        height: 44px;
        width: calc(100% - 30px);
        padding: 0 15px;
        background: #000;
        color: #fff;
        line-height: 44px;
        margin-top: -44px;
        z-index: 999;
        position: absolute;
        bottom: 0;
    }

    .bar>span {
        cursor: pointer;
    }

    .video_change {
        width: fit-content;
        height: -webkit-fit-content;
        height: -moz-fit-content;
        height: fit-content;
        position: absolute;
        bottom: 44px;
        background: #000000b5;
        left: 0;
        padding: 0 15px;
    }

    .video_change>div:hover {
        color: #009688;
        cursor: pointer;
    }

    .yt_box {
        width: 150px;
        height: 150px;
        margin: auto;
        border-radius: 50%;
        transform: rotate(45deg);
        /* display: none; */
        /* position: absolute; */
        left: 0;
        right: 0;
        top: 370px;
        margin-top: 40px;
    }

    .yt_bj {
        width: 100%;
        height: 100%;
    }

    .yt_btn_box {
        position: absolute;
        top: 0;
        left: 0;
        width: 150px;
        height: 150px;
        /* padding: 10px; */
        /* display: flex; */
        /* width: calc(100% - 20px); */
        /* flex-wrap: wrap; */
    }

    .yt_btn_box>div {
        width: 60px;
        height: 60px;
        user-select: none;
    }

    .yt_btn_box img {
        width: 100%;
        height: 100%;
        -webkit-user-drag: none;
    }

    .yt_btn_box .top {
        position: absolute;
        left: 10px;
        top: 10px;
        border-radius: 100% 0 0 0;
        overflow: hidden;
    }

    .yt_btn_box .right {
        position: absolute;
        right: 10px;
        top: 10px;
        border-radius: 0 100% 0 0;
        overflow: hidden;
    }

    .yt_btn_box .bottom {
        position: absolute;
        right: 10px;
        bottom: 10px;
        border-radius: 0 0 100% 0;
        overflow: hidden;
    }

    .yt_btn_box .left {
        position: absolute;
        left: 10px;
        bottom: 10px;
        border-radius: 0 0 0 100%;
        overflow: hidden;
    }

    .yt_btn_box>div:active {
        transform: scale(0.96);
    }

    .touch {
        transform: scale(0.96);
    }

    .block {
        display: flex;
        justify-content: center;
        line-height: 36px;
        margin-top: 15px;
    }

    .vv {
        position: relative;
    }

    .badge_num {
        margin-right: 20px;
    }

    .none {
        margin: auto;
        margin-top: 100px;
        text-align: center;
        color: #9e9e9e;
    }
    .warning_title{
        text-align: center;
        line-height: 40px;
        border-bottom: 1px solid #e9e9e9;
        margin-top: 20px;
    }
    .tvoc_name{
        display: flex;
        justify-content: space-between;
    }
    .jk_zp{
        color: #009688;
        cursor: pointer;
    }
    .tvoc_warning{
        line-height: 24px;
        font-size: 14px;
        color: #333;
        position: relative;
    }
    .warning_time{
        color: #686868;
        font-size: 12px;
    }
    .warning_info{
        font-size: 12px;
    }
    .jk_box{
        position: absolute;
        right: 15px;
    }
    .jk_img{
        width: 100px;
    }
    .filter_box{
        position: absolute;
        right: 20px;
        bottom: 20px;
        z-index: 1001;
        user-select: none;
        
    }
    .filter_item{
        margin-bottom: 20px;
        display: flex;
        font-size: 12px;
        justify-content: right;
        flex-flow: row-reverse;
    }
    .filter_item .item{
        width: 40px;
        height: 40px;
        background: #fff;
        border-radius: 6px;
        text-align: center;
        line-height: 40px;
        margin-right: 20px;
        align-content: center;
        position: relative;
        cursor: pointer;
    }
    .filter_item img{
        width: 30px;
        height: 32px;
        margin-top: 4px;
    }
    .filter_icon{
        position: absolute;
        right: 0;
        bottom: 0;
        color: #009688;
        font-size: 20px;
    }
</style>
<style>
    .my_drawer {
        width: 600px !important;
    }

    .contract_drawer {
        width: 500px !important;
    }

    .access_drawer {
        width: 500px !important;
    }

    .rectification_drawer {
        width: 500px !important;
    }

    .device_drawer {
        width: 700px !important;
    }
    .search .el-input__inner{
        height: 45px;
        line-height: 45px;
        border: none;
    }
</style>
<template>
    <div id="app">
        <div id="container"></div>
        <div class="filter_box">
            <div class="filter_item">
                <div class="item" v-for="(item,index) in status" :key="index" @click="select_filter('status',index)">
                    <i class='el-icon-check filter_icon' v-if="item.is==1"></i>
                    <img :src="'/static/'+item.name+'.png'" alt="" v-if="index!='0'" @dragstart.prevent>
                    <span v-else>{{item.name}}</span>
                </div>
            </div>
            <div class="filter_item">
                <div class="item" v-for="(item,index) in type_name" :key="index" @click="select_filter('type_name',index)">
                    <i class='el-icon-check filter_icon' v-if="item.is==1"></i>
                    <span>{{item.name}}</span>
                </div>
            </div>
            <div class="filter_item">
                <div class="item" v-for="(item,index) in class_name" :key="index" @click="select_filter('class_name',index)">
                    <i class='el-icon-check filter_icon' v-if="item.is==1"></i>
                    <span>{{item.name}}</span>
                </div>
            </div>
            <div class="filter_item">
                <div class="item" v-for="(item,index) in is_device" :key="index" @click="select_filter('is_device',index)">
                    <i class='el-icon-check filter_icon' v-if="item.is==1"></i>
                    <span>{{item.name}}</span>
                </div>
            </div>
        </div>
        <!-- <input type="text" placeholder="请输入搜索内容(回车搜索)" class='search' v-model="search" @keyup.enter="onSubmit" :style="'z-index:'+(drawer?'99':'9999')"> -->
        <el-autocomplete class="search" @keyup.enter.native="onSubmit" :style="'z-index:'+(drawer?'99':'9999')" v-model="search" :select-when-unmatched="true" :fetch-suggestions="querySearch" placeholder="请输入搜索内容(回车搜索)" :trigger-on-focus="false" @select="onSubmit"></el-autocomplete>
        <el-drawer custom-class='my_drawer' :visible.sync="drawer" :direction="direction" :with-header="false">
            <div class="info_box" v-if="unit!=null">
                <div class="title">
                    <p>企业信息</p>
                    <el-row>
                        <el-badge :value="unit.contract.length" class='badge_num'>
                            <el-button size="mini" @click="contract_drawer = true">合同/联单</el-button>
                        </el-badge>
                        <el-badge :value="unit.access_record.length" class='badge_num'>
                            <el-button size="mini" @click="access_drawer = true">排查记录</el-button>
                        </el-badge>
                        <el-badge :value="unit.rectification.length" class='badge_num'>
                            <el-button size="mini" @click="rectification_drawer = true">整改通知</el-button>
                        </el-badge>
                        <el-badge class='badge_num'>
                            <el-button size="mini" @click="show_device()">监测数据</el-button>
                        </el-badge>
                    </el-row>
                    <img src="/static/close.png" class="close" @click="handleClose">
                </div>
                <div class="item_box">
                    <div class="item">
                        <span>单位名称</span>
                        <span>{{unit.unit_name}}</span>
                    </div>
                    <div class="item">
                        <span>所属区域</span>
                        <span>{{unit.city}}</span>
                    </div>
                    <div class="item">
                        <span>采集定位</span>
                        <span>{{unit.address}}</span>
                    </div>
                    <div class="item">
                        <span>联系人</span>
                        <span>{{unit.user_name}}</span>
                    </div>
                    <div class="item">
                        <span>联系电话</span>
                        <span>{{unit.tel}}</span>
                    </div>
                    <div class="item">
                        <span>企业类型</span>
                        <span>
                            <span class="unit_type" v-for="item,index in unit.type" :key="index">{{item | unit}}</span>
                        </span>
                    </div>
                    <div class="item">
                        <span>企业类目</span>
                        <span>{{unit.class|class}}</span>
                    </div>
                    <div class="item">
                        <span>企业状态</span>
                        <span><img :src="'/static/'+unit.unit_type+'.png'" class='status_img' alt=""></span>
                    </div>
                    <div class="item">
                        <span>证件照片</span>
                    </div>
                    <!-- <div class="item">
                        <el-image 
                            class='zj'
                            fit="cover"
                            v-if="unit.yyzz"
                            :src="domain+unit.yyzz"
                            :preview-src-list="[domain+unit.yyzz,domain+unit.badj]">
                        </el-image>
                        <el-image 
                            class='zj'
                            fit="cover"
                            v-if="unit.badj" 
                            :src="domain+unit.badj"
                            :preview-src-list="[domain+unit.yyzz,domain+unit.badj]">
                        </el-image>
                    </div> -->
                    <viewer class="item">
                        <img v-if="unit.yyzz" :src="domain+unit.yyzz" class='zj' alt="">
                        <img v-if="unit.badj" :src="domain+unit.badj" class='zj' alt="">
                    </viewer>
                    <div class="item">
                        <span>采集照片</span>
                    </div>
                    <viewer :images="[]" class="item">
                        <img v-for="item,index in unit.picture" :key="index" :src="domain+item" class='pic' alt="">
                    </viewer>
                </div>
            </div>
        </el-drawer>
        <el-drawer title="合同信息" custom-class='contract_drawer' :visible.sync="contract_drawer" :direction="contract_direction" :modal="true" :with-header="false">
            <div class="info_box" v-if="unit!=null">
                <div class="title">
                    <p>合同信息</p>
                    <img src="/static/close.png" class="close" @click="contract_drawer=false">
                </div>
                <template v-if="unit.contract.length>0">
                    <template v-for="(item, index) in unit.contract">
                        <div class="item_box" :key="item.id" v-if="item.name!=''">
                            <div class="item">
                                <span>{{index+1}}.{{item.text}}</span>
                            </div>
                            <div class="item">
                                <span>乙方名称</span>
                                <span>{{item.name}}</span>
                            </div>
                            <div class="item">
                                <span>有限期至</span>
                                <span>{{item.time}}</span>
                            </div>
                            <viewer :images="[]" class="item">
                                <img v-for="(ite,ins) in item.img.split(',')" :key="ins" :src="domain+ite" class='contract_img' alt="">
                            </viewer>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <div class="none">
                        <img src="/static/none.png">
                        <p>暂无数据</p>
                    </div>
                </template>
            </div>
        </el-drawer>
        <el-drawer title="排查记录" custom-class='access_drawer' :visible.sync="access_drawer" :direction="access_direction" :modal="true" :with-header="false">
            <div class="info_box" v-if="unit!=null">
                <div class="title">
                    <p>排查记录</p>
                    <el-row>
                        <el-button size="mini" @click="dialogFormVisible = true">提交整改通知</el-button>
                    </el-row>
                    <img src="/static/close.png" class="close" @click="access_drawer=false">
                </div>
                <template v-if="unit.access_record.length>0">
                    <div class="item_box" v-for="(item, index) in unit.access_record" :key="item.id">
                        <div class="item">
                            <span>第{{index+1}}次排查</span>
                            <span>
                                <viewer v-if="item.sign"><img :src="domain+item.sign" class="sign_img"></viewer>
                            </span>
                        </div>
                        <div class="item">
                            <span>排查时间</span>
                            <span>{{item.time}}</span>
                        </div>
                        <div class="item">
                            <span>记录内容</span>
                            <span>{{item.remark==''?'本次未填写记录':item.remark}}</span>
                        </div>
                        <div class="item">
                            <span>排查人员</span>
                            <span>{{item.username}}</span>
                        </div>
                        <viewer :images="[]" class="item">
                            <img v-for="(ite,ins) in item.picture.split(',')" :key="ins" :src="domain+ite" class='access_img' alt="">
                        </viewer>
                    </div>
                </template>
                <template v-else>
                    <div class="none">
                        <img src="/static/none.png">
                        <p>暂无数据</p>
                    </div>
                </template>
            </div>
        </el-drawer>
        <el-dialog title="提交整改通知" :visible.sync="dialogFormVisible">
            <el-form :model="form" :rules="rules" ref="ruleForm" :label-width="formLabelWidth">
                <el-form-item label="问题描述" prop="title">
                    <el-input v-model="form.title" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="问题内容" prop="content">
                    <el-input type="textarea" v-model="form.content" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="整改期限" prop="last_time">
                    <el-date-picker
                        v-model="form.last_time"
                        type="date"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        placeholder="选择整改期限">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="相关图片">
                    <el-upload
                        class="upload-demo"
                        ref="upload"
                        :data="{token:token}"
                        action="/api/upload_img"
                        multiple
                        accept="image/*"
                        :auto-upload='true'
                        :on-success="upload_success"
                        :on-error="upload_error"
                        :on-remove="remove_img"
                        :file-list="form.picture"
                        list-type="picture">
                        <el-button size="small" type="primary"><i class="el-icon-upload"></i>添加图片</el-button>
                        <!-- <i class="el-icon-upload"></i> -->
                        <!-- <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div> -->
                    </el-upload>
                </el-form-item>
                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitUpload('ruleForm')">提 交</el-button>
            </div>
        </el-dialog>
        <el-drawer title="整改通知" custom-class='rectification_drawer' :visible.sync="rectification_drawer" :direction="rectification_direction" :modal="true" :with-header="false">
            <div class="info_box" v-if="unit!=null">
                <div class="title">
                    <p>整改通知</p>
                    <img src="/static/close.png" class="close" @click="rectification_drawer=false">
                </div>
                <template v-if="unit.rectification.length>0">
                    <div class="item_box" v-for="(item, index) in unit.rectification" :key="item.id">
                        <div class="item">
                            <span>第{{unit.rectification.length-index}}次整改</span>
                            <span>{{item.title}}</span>
                        </div>
                        <div class="item">
                            <span>最后期限</span>
                            <span>{{item.last_time}}</span>
                        </div>
                        <div class="item">
                            <span>整改内容</span>
                            <span>{{item.content}}</span>
                        </div>
                        <div class="item">
                            <span>提交时间</span>
                            <span>{{item.time}}</span>
                        </div>
                        <div class="item">
                            <span>整改状态</span>
                            <span>{{item.status|status}}</span>
                        </div>
                        <viewer :images="[]" class="item">
                            <img v-for="(ite,ins) in item.picture.split(',')" :key="ins" :src="domain+ite" class='access_img' alt="">
                        </viewer>
                        <template v-if="item.status>1">
                            <div class="item">
                                <span><b>整改回复</b></span>
                            </div>
                            <div class="item">
                                <span>回复时间</span>
                                <span>{{item.return_time}}</span>
                            </div>
                            <div class="item">
                                <span>回复内容</span>
                                <span>{{item.return_content}}</span>
                            </div>
                            <div class="item">
                                <span>上传照片</span>
                            </div>
                            <viewer :images="[]" class="item">
                                <img v-for="(ite,ins) in item.return_picture.split(',')" :key="ins" :src="domain+ite" class='access_img' alt="">
                            </viewer>
                        </template>

                    </div>
                </template>
                <template v-else>
                    <div class="none">
                        <img src="/static/none.png">
                        <p>暂无数据</p>
                    </div>
                </template>
            </div>
        </el-drawer>
        <el-drawer title="监测数据" custom-class='device_drawer' :visible.sync="device_drawer" :direction="device_direction" :modal="true" :with-header="false" :before-close="close_device">
            <div class="info_box" v-if="device!=null">
                <div class="title">
                    <p>监测数据</p>
                    <img src="/static/close.png" class="close" @click="close_device()">
                </div>
                <template v-if="device.camera.length==0 && device.tvoc.length==0">
                    <div class="none">
                        <img src="/static/none.png">
                        <p>暂无数据</p>
                    </div>
                </template>
                <template v-if="device.camera.length>0">
                    <div class="vv">
                        <div id="video" class='video_box' data-sn='' data-channel=''></div>
                        <div class="bar">
                            <div class="video_change" :style="'display:'+display_change_video">
                                <div v-for="(item,index) in device.camera" :key="item.id" @click="change_video(index)">{{item.name}}</div>
                            </div>
                            <span @click="display_change_video=display_change_video=='block'?'none':'block'">{{device.camera[camera_index].name}}</span>
                        </div>
                    </div>

                    <div class="block">
                        <span class="demonstration">云台移动距离</span>
                        <el-slider v-model="move_time" :min=1 show-input style="width:400px;margin-left:20px;"></el-slider>
                    </div>

                    <div class='yt_box'>
                        <img src="/static/yt_bj.png" class="yt_bj">
                        <div class='yt_btn_box'>
                            <div class="top" @click='move_yt("top")'><img src='/static/yt_top.png'></div>
                            <div class="right" @click='move_yt("right")'><img src='/static/yt_right.png'></div>
                            <div class="bottom" @click='move_yt("bottom")'><img src='/static/yt_bottom.png'></div>
                            <div class="left" @click='move_yt("left")'><img src='/static/yt_left.png'></div>
                        </div>
                    </div>
                </template>
                <template v-if="device.tvoc.length>0">
                    <div class="item_box echarts_box" v-for="(item, index) in device.tvoc" :key="item.id">
                        <div :id="'zxt'+index" class="echarts_zxt"></div>
                    </div>
                </template>
                <template v-if="device.tvoc_warning.length>0">
                    <div class="warning_title">
                        <span>TVOC报警信息</span>
                    </div>
                    <div class="item_box tvoc_warning" v-for="(item) in device.tvoc_warning" :key="item.id">
                        <div class="tvoc_name">
                            <span>{{item.name}}</span>
                            <el-image v-if="item.img!='未抓拍照片'"
                                style="height: 22px"
                                src="/static/jk_icon.png" 
                                :preview-src-list="item.img.split(',')">
                            </el-image>
                            <!-- <span class='jk_zp'>相关监控</span> -->
                        </div>
                        <div class="warning_time">
                            <span>{{item.date}}</span>
                        </div>
                        <div class="warning_info">
                            <span>报警信息:监测值:{{item.tvoc}}mg/m³,超过报警值0.075mg/m³</span>
                        </div>
                    </div>
                </template>
            </div>
        </el-drawer>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                unit_list:[],
                status:{
                    '0':{name:'不限',value:'0',is:1},
                    'lv':{name:'lv',value:'lv',is:0},
                    'huang':{name:'huang',value:'huang',is:0},
                    'hong':{name:'hong',value:'hong',is:0},
                    'hei':{name:'hei',value:'hei',is:0},
                    'wu':{name:'wu',value:'wu',is:0},
                },
                type_name:{
                    '0':{name:'不限',value:'0',is:1},
                    'jx':{name:'机修',value:'jx',is:0},
                    'qf':{name:'漆房',value:'qf',is:0},
                    'lt':{name:'轮胎',value:'lt',is:0},
                    'dp':{name:'电瓶',value:'dp',is:0},
                },
                class_name:[
                    {name:'不限',value:'none',is:1},
                    {name:'一类',value:'1',is:0},
                    {name:'二类',value:'2',is:0},
                    {name:'三类',value:'3',is:0},
                ],
                is_device:[
                    {name:'不限',value:'none',is:1},
                    {name:'有设备',value:'1',is:0},
                    {name:'无设备',value:'0',is:0},
                ],

                select_status:[1,2,3,4],
                select_type:['lv','huang','hong','hei','wu'],

                token:window.localStorage.getItem('token'),
                domain: this.$store.state.domain,
                map: null,
                search: '',
                coords: [],
                markers: [],
                geometries: [],
                last_info: null,
                markerLayer: null,
                reload: 0,
                icon: {
                    lv: require('../assets/lv.png')
                },
                unit: null,
                device: null,
                drawer: false,
                direction: 'ltr',
                contract_drawer: false,
                contract_direction: 'rtl',
                access_drawer: false,
                access_direction: 'rtl',
                rectification_drawer: false,
                rectification_direction: 'rtl',
                device_drawer: false,
                device_direction: 'rtl',
                chartDom: [],
                myChart: [],
                player: null,
                move_time: 30,
                camera_index: 0,
                display_change_video: 'none',
                restaurants: [],
                dialogFormVisible:false,
                form: {
                    factory_id:'',
                    title: '',
                    last_time: '',
                    content: '',
                    picture: [],
                },
                formLabelWidth: '120px',
                rules: {
                    title: [
                        { required: true, message: '请输入问题描述', trigger: 'blur' },
                    ],
                    content: [
                        { required: true, message: '请输入问题内容', trigger: 'blur' },
                    ],
                    last_time: [
                        { required: true, message: '请选择整改期限', trigger: 'change' }
                    ]
                },
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7
                    }
                },
            };
        },
        mounted() {
            this.init();
        },
        filters: {
            unit(item) {
                if (item == 'jx') {
                    return '机修'
                }
                else if (item == 'qf') {
                    return '漆房'
                }
                else if (item == 'lt') {
                    return '轮胎'
                }
                else if (item == 'dp') {
                    return '电瓶'
                }
            },
            class(item) {
                if (item == 0) {
                    return '未选择类目'
                }
                else if (item == 1) {
                    return '一类'
                }
                else if (item == 2) {
                    return '二类'
                }
                else if (item == 3) {
                    return '三类'
                }
            },
            status(item) {
                if (item == 1) {
                    return '未整改'
                }
                else if (item == 2) {
                    return '审核中'
                }
                else if (item == 3) {
                    return '已结案'
                }
            },
        },
        //方法
        methods: {
            select_filter(data,ins){
                if(ins=='none' || ins==0){
                    this[data][ins].is = 1
                    if(data=='status'){
                        this.status.lv.is=0;
                        this.status.huang.is=0;
                        this.status.hong.is=0;
                        this.status.hei.is=0;
                        this.status.wu.is=0;
                    }else if(data=='type_name'){
                        this.type_name.jx.is=0;
                        this.type_name.qf.is=0;
                        this.type_name.lt.is=0;
                        this.type_name.dp.is=0;
                    }else if(data=='class_name'){
                        this.class_name[1].is=0;
                        this.class_name[2].is=0;
                        this.class_name[3].is=0;
                    }else if(data=='is_device'){
                        this.is_device[1].is=0;
                        this.is_device[2].is=0;
                    }
                }else{
                    this[data][0].is = 0
                    this[data][ins].is=this[data][ins].is==1?0:1
                }
                this.reload=1
                this.initMap()
            },
            querySearch(queryString, cb) {
                if(queryString){
                    console.log(queryString)
                    var restaurants = this.restaurants;
                    var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                    console.log(results)
                    // 调用 callback 返回建议列表的数据
                    cb(results);
                }else{
                    this.onSubmit();
                }
                
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) != -1);
                };
            },
            handleSelect(item) {
                console.log(item);
            },
            onSubmit() {
                this.reload = 1;
                this.get_data()
            },
            init() {
                this.map = new TMap.Map(document.getElementById('container'), {
                    // center: center,//设置地图中心点坐标
                    zoom: 20, //设置地图缩放级别
                    pitch: 0, //设置俯仰角
                    rotation: 45, //设置地图旋转角度
                });
                this.get_data();
            },
            get_data() {
                this.loading = this.$loading({
                    lock: true,
                    text: '数据查询中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.4)'
                });
                var _this = this;
                this.$axios.post(
                    '/api/get_factory', { search: this.search, token: window.localStorage.getItem('token') }
                ).then(function (res) {
                    console.log(res)
                    var data = res.data;
                    if(_this.reload==0){
                        _this.restaurants= JSON.parse(JSON.stringify(data.data).replace(/unit_name/g,"value"));
                    }
                    _this.unit_list = data.data

                    _this.loading.close()
                    if (data.code == '200ok') {
                        _this.initMap()
                    } else {
                        _this.$message.error(data.msg)
                    }
                }).catch(function (error) {
                    console.log(error);
                    _this.loading.close()
                    _this.$message.error('网络异常,数据请求失败')
                })
            },
            initMap() {
                var data = JSON.parse(JSON.stringify(this.unit_list))
                this.markers = [];
                this.coords = []
                this.geometries = []

                if (this.reload) {
                    this.markerLayer.setMap(null)
                }

                console.log(data)
                data.forEach(item => {
                    if(this.reload){
                        var flag1 = false;
                        var flag2 = false;
                        var flag3 = false;
                        var flag4 = false;
                        if(this.status[0].is==1){
                            flag1 = true;
                        }else{
                            if(this.status[item.unit_type].is==1){
                                flag1 = true;
                            }
                        }
                        if(flag1){
                            if(this.type_name[0].is==1){
                                flag2 = true;
                            }else{
                                var type_arr = item.type.split(',')
                                for(var i =0;i<type_arr.length;i++){
                                    var type = type_arr[i];
                                    if(type!='' && this.type_name[type].is==1){
                                        flag2 = true;
                                        break;
                                    }
                                }
                            }
                        }
                        if(flag2){
                            if(this.class_name[0].is==1){
                                flag3 = true;
                            }else{
                                if(this.class_name[item.class].is==1){
                                    flag3 = true;
                                }
                            }
                        }
                        if(flag3){
                            if(this.is_device[0].is==1){
                                flag4 = true;
                            }else{
                                if(this.is_device[1].is==1 && parseInt(item.camera_num)+parseInt(item.tvoc_num)>0){
                                    flag4=true;
                                }else if(this.is_device[2].is==1 && parseInt(item.camera_num)+parseInt(item.tvoc_num)==0){
                                    flag4=true;
                                }
                            }
                        }
                        
                        // if(this.status[item.unit_type].is==1){
                        //     console.log(item.class)
                        //     flag1 = true;
                        //     var type_arr = item.type.split(',')
                        //     // flag2 = true;
                        //     for(var i =0;i<type_arr.length;i++){
                        //         console.log(type_arr[i],item.id)
                        //         if(this.type_name[type_arr[i]].is==1){
                        //             flag2 = true;
                        //             // return false;
                        //         }
                        //     }
                        //     if(flag2 && this.class_name[parseInt(item.class)].is==1){
                        //         flag3 = true;
                        //         if(this.is_device[0].is==1 && this.is_device[1].is==1){
                        //             flag4=true;
                        //         }else if(this.is_device[0].is==1 && parseInt(item.camera_num)+parseInt(item.tvoc_num>0)){
                        //             flag4=true;
                        //         }else if(this.is_device[1].is==1 && parseInt(item.camera_num)+parseInt(item.tvoc_num)==0){
                        //             flag4=true;
                        //         }
                        //     }
                        // }
                    }else{
                        var flag = true;
                    }
                    

                    

                    if(flag || flag1 && flag2 && flag3 && flag4){
                        var temp = {
                            "id": item.id, //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
                            "styleId": item.unit_type, //指定样式id
                            "position": new TMap.LatLng(item.latitude, item.longitude), //点标记坐标位置
                            "properties": { //自定义属性
                                "title": item.unit_name
                            }
                        }
                        this.markers.push(temp);

                        var t = new TMap.LatLng(item.latitude, item.longitude);
                        this.coords.push(t);

                        var tt = { position: new TMap.LatLng(item.latitude, item.longitude) };
                        this.geometries.push(tt)
                    }
                   
                });
                var _this = this;
                setTimeout(function () {
                    //创建LatLngBounds实例
                    var latlngBounds = new TMap.LatLngBounds();
                    //将坐标逐一做为参数传入extend方法，latlngBounds会根据传入坐标自动扩展生成
                    for (var i = 0; i < _this.coords.length; i++) {
                        latlngBounds.extend(_this.coords[i]);
                    }
                    //调用fitBounds自动调整地图显示范围
                    _this.map.fitBounds(latlngBounds, { padding: 100 });
                }, 300)

                //创建并初始化MultiMarker
                this.markerLayer = new TMap.MultiMarker({
                    map: this.map, //指定地图容器
                    //样式定义
                    styles: {
                        //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                        "lv": new TMap.MarkerStyle({
                            "width": 45, // 点标记样式宽度（像素）
                            "height": 49, // 点标记样式高度（像素）
                            "cursor": "pointer",
                            "src": '/static/lv.png', //图片路径
                            //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                            "anchor": { x: 22.5, y: 49 }
                        }),
                        //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                        "huang": new TMap.MarkerStyle({
                            "width": 45, // 点标记样式宽度（像素）
                            "height": 49, // 点标记样式高度（像素）
                            "cursor": "pointer",
                            "src": '/static/huang.png', //图片路径
                            //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                            "anchor": { x: 22.5, y: 49 }
                        }),
                        //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                        "hong": new TMap.MarkerStyle({
                            "width": 45, // 点标记样式宽度（像素）
                            "height": 49, // 点标记样式高度（像素）
                            "cursor": "pointer",
                            "src": '/static/hong.png', //图片路径
                            //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                            "anchor": { x: 22.5, y: 49 }
                        }),
                        //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                        "hei": new TMap.MarkerStyle({
                            "width": 45, // 点标记样式宽度（像素）
                            "height": 49, // 点标记样式高度（像素）
                            "cursor": "pointer",
                            "src": '/static/hei.png', //图片路径
                            //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                            "anchor": { x: 22.5, y: 49 }
                        }),
                        //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                        "wu": new TMap.MarkerStyle({
                            "width": 45, // 点标记样式宽度（像素）
                            "height": 49, // 点标记样式高度（像素）
                            "cursor": "pointer",
                            "src": '/static/wu.png', //图片路径
                            //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                            "anchor": { x: 22.5, y: 49 }
                        }),
                        //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                        "big_lv": new TMap.MarkerStyle({
                            "width": 55, // 点标记样式宽度（像素）
                            "height": 59, // 点标记样式高度（像素）
                            "cursor": "pointer",
                            "src": '/static/lv.png', //图片路径
                            //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                            "anchor": { x: 27.5, y: 59 }
                        }),
                        //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                        "big_huang": new TMap.MarkerStyle({
                            "width": 55, // 点标记样式宽度（像素）
                            "height": 59, // 点标记样式高度（像素）
                            "cursor": "pointer",
                            "src": '/static/huang.png', //图片路径
                            //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                            "anchor": { x: 27.5, y: 59 }
                        }),
                        //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                        "big_hong": new TMap.MarkerStyle({
                            "width": 55, // 点标记样式宽度（像素）
                            "height": 59, // 点标记样式高度（像素）
                            "cursor": "pointer",
                            "src": '/static/hong.png', //图片路径
                            //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                            "anchor": { x: 27.5, y: 59 }
                        }),
                        //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                        "big_hei": new TMap.MarkerStyle({
                            "width": 55, // 点标记样式宽度（像素）
                            "height": 59, // 点标记样式高度（像素）
                            "cursor": "pointer",
                            "src": '/static/hei.png', //图片路径
                            //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                            "anchor": { x: 27.5, y: 59 }
                        }),
                        //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                        "big_wu": new TMap.MarkerStyle({
                            "width": 55, // 点标记样式宽度（像素）
                            "height": 59, // 点标记样式高度（像素）
                            "cursor": "pointer",
                            "src": '/static/wu.png', //图片路径
                            //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                            "anchor": { x: 27.5, y: 59 }
                        }),
                    },
                    //点标记数据数组
                    // geometries: _this.markers
                });
                this.markerLayer.add(this.markers); //添加点

                //监听标记点点击事件
                this.markerLayer.on("click", function (e) {
                    console.log(e)
                    var id = e.geometry.id;
                    var styleId = e.geometry.styleId;
                    var position = e.geometry.position;
                    var title = e.geometry.properties.title;

                    _this.get_factory_info(id);

                    _this.markerLayer.updateGeometries([
                    {
                        "styleId": 'big_' + styleId,
                        "id": id,
                        "position": position,
                        "properties": { //自定义属性
                            "title": title
                        }
                    }])
                    if (_this.last_info) {
                        _this.markerLayer.updateGeometries([
                        {
                            "styleId": _this.last_info.styleId,
                            "id": _this.last_info.id,
                            "position": _this.last_info.position,
                            "properties": { //自定义属性
                                "title": _this.last_info.properties.title
                            }
                        }])
                    }

                    _this.map.setCenter(position)
                    _this.map.setZoom(16)
                    _this.map.setPitch(30)
                    _this.last_info = e.geometry;
                })
            },
            //查询企业信息
            get_factory_info(id) {
                this.form.factory_id = id;
                //查询信息
                var _this = this;
                _this.loading = _this.$loading({
                    lock: true,
                    text: '数据查询中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.4)'
                });
                _this.$axios.post(
                    '/api/get_factory_info_to_id', { id: id }
                ).then(function (res) {
                    console.log(res)
                    _this.unit = res.data.data
                    _this.device = res.data.device
                    var data = res.data;
                    _this.loading.close()
                    if (data.code == '200ok') {
                        _this.drawer = true;
                    } else {
                        _this.$message.error(data.msg)
                    }
                }).catch(function (error) {
                    console.log(error);
                    _this.loading.close()
                    _this.$message.error('网络异常,数据请求失败')
                })
            },

            handleClose(done) {
                this.drawer = false;
                this.contract_drawer = false;
            },
            change_video(index) {
                this.camera_index = index;
                this.display_change_video = 'none';
                var camera = this.device.camera;
                var src = [
                {
                    url: 'imou://open.lechange.com/' + camera[index].sn + '/' + camera[index].channel + '/1?streamId=0',
                    kitToken: camera[index].kit_token,
                }]
                // 销毁播放器
                this.player.destroy();
                this.player = new ImouPlayer('#video');
                // 播放器初始化
                this.player.setup({
                    src: src, // 播放地址
                    width: 700, // 播放器宽度
                    height: 400, // 播放器高度
                    poster: '', // 封面图url
                    autoplay: true, // 是否自动播放
                    controls: true, // 是否展示控制栏
                });
            },
            show_device() {
                this.device_drawer = true;
                var index = this.camera_index
                var _this = this;
                setTimeout(function () {
                    //是否有监控
                    if (_this.device.camera.length > 0) {
                        var camera = _this.device.camera;
                        _this.player = new ImouPlayer('#video');
                        var src = [
                        {
                            url: 'imou://open.lechange.com/' + camera[index].sn + '/' + camera[index].channel + '/1?streamId=0',
                            kitToken: camera[index].kit_token,
                        }]

                        // 播放器初始化
                        _this.player.setup({
                            src: src, // 播放地址
                            width: 700, // 播放器宽度
                            height: 400, // 播放器高度
                            poster: '', // 封面图url
                            autoplay: true, // 是否自动播放
                            controls: true, // 是否展示控制栏
                        });
                    }

                    //是否有tvoc
                    if (_this.device.tvoc.length > 0) {
                        // $('.echarts_box').css('padding','20px');
                        var chartDom = [];
                        var myChart = [];
                        for (var i = _this.device.tvoc.length - 1; i >= 0; i--) {
                            // var html = '<div id="zxt'+i+'" class="echarts_zxt"></div>'
                            // $('.echarts_box').prepend(html)
                            var option = {
                                title: {
                                    text: _this.device.tvoc[i].name + '-TVOC挥发气体实时检测',
                                    left: 'center',
                                    textStyle: {
                                        color: '#333333',
                                        fontWeight: 'bold',
                                        fontSize: 16
                                    }
                                },

                                grid: {
                                    containLabel: true,
                                    left: 0,
                                    right: '10'
                                },
                                tooltip: {
                                    show: true,
                                    trigger: 'axis',
                                },
                                xAxis: {
                                    type: 'category',
                                    boundaryGap: false,
                                    data: _this.device.tvoc[i].date,
                                    // show: false
                                },
                                yAxis: {
                                    x: 'center',
                                    type: 'value',
                                    splitLine: {
                                        lineStyle: {
                                            type: 'dashed'
                                        }
                                    }
                                    // show: false
                                },
                                dataZoom: [{
                                    type: 'slider',
                                    start: 70,
                                    end: 100
                                },
                                {
                                    start: 70,
                                    end: 100
                                }],
                                visualMap: { //区间内控制显示颜色
                                    show: false,
                                    dimension: 1,
                                    pieces: [{
                                        gt: 0,
                                        lte: 0.01,
                                        color: '#00ff00'
                                    },
                                    {
                                        gt: 0.01,
                                        lte: 0.02,
                                        color: '#5dff00'
                                    },
                                    {
                                        gt: 0.02,
                                        lte: 0.03,
                                        color: '#7fff00'
                                    },
                                    {
                                        gt: 0.03,
                                        lte: 0.04,
                                        color: '#95ff00'
                                    },
                                    {
                                        gt: 0.04,
                                        lte: 0.05,
                                        color: '#acff00'
                                    },
                                    {
                                        gt: 0.05,
                                        lte: 0.06,
                                        color: '#d9ff00'
                                    },
                                    {
                                        gt: 0.06,
                                        lte: 0.07,
                                        color: '#fff800'
                                    },
                                    {
                                        gt: 0.07,
                                        lte: 0.08,
                                        color: '#ffc000'
                                    },
                                    {
                                        gt: 0.08,
                                        lte: 0.09,
                                        color: '#ff9300'
                                    },
                                    {
                                        gt: 0.09,
                                        lte: 0.1,
                                        color: '#ff6600'
                                    },
                                    {
                                        gt: 0.1,
                                        lte: 0.12,
                                        color: '#ff4400'
                                    },
                                    {
                                        gt: 0.11,
                                        lte: 0.13,
                                        color: '#ff3900'
                                    },
                                    {
                                        gt: 0.12,
                                        lte: 0.14,
                                        color: '#ff2300'
                                    },
                                    {
                                        gt: 0.13,
                                        lte: 0.15,
                                        color: '#ff0c00'
                                    },
                                    {
                                        gt: 0.14,
                                        color: '#ff0000'
                                    }],
                                },
                                series: [{
                                    name: 'TVOC',
                                    type: 'line',
                                    smooth: true,
                                    stock: 'mg/m3',
                                    data: _this.device.tvoc[i].tvoc,
                                    markLine: { //添加警戒线
                                        symbol: "none", //去掉警戒线最后面的箭头
                                        name: "警戒线",
                                        silent: true,
                                        label: {
                                            position: "middle", //将警示值放在哪个位置，三个值“start”,"middle","end"  开始  中点 结束
                                            formatter: "报警值:0.075",
                                            color: "red",
                                            // fontSize:14
                                        },
                                        data: [{
                                            silent: true, //鼠标悬停事件  true没有，false有
                                            lineStyle: { //警戒线的样式  ，虚实  颜色
                                                type: "solid",
                                                color: "red"
                                            },
                                            name: '警戒线',
                                            yAxis: 0.075
                                        }]
                                    }
                                }]
                            };
                            chartDom[i] = document.getElementById('zxt' + i);
                            console.log(chartDom[i])
                            myChart[i] = _this.$echarts.init(document.getElementById('zxt' + i));
                            myChart[i].setOption(option)
                        }
                    }
                }, 100)

            },
            close_device() {
                this.device_drawer = false
                // 销毁播放器
                this.player.destroy();
            },
            move_yt(operation) {
                //移动云台
                var move_time = this.move_time;
                var camera_index = this.camera_index
                var camera = this.device.camera

                this.loading = this.$loading({
                    lock: true,
                    text: '云台移动中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.4)'
                });
                var _this = this;
                this.$axios.post(
                    '/api/move_ptz',
                    {
                        sn: camera[camera_index].sn,
                        channel: camera[camera_index].channel,
                        operation: operation,
                        time: move_time * 10
                    }
                ).then(function (res) {
                    console.log(res)
                    var data = res.data;
                    _this.loading.close()
                    if (data.code == '200ok') {

                    } else {
                        _this.$message.error(data.msg)
                    }
                }).catch(function (error) {
                    console.log(error);
                    _this.loading.close()
                    _this.$message.error('网络异常,数据请求失败')
                })
            },
            upload_success(res, file, fileList){
                console.log(res, file, fileList)
                this.form.picture=fileList
                if(res.code==0){
                    this.$notify({
                        title: '成功',
                        message: '图片添加成功',
                        type: 'success'
                    });
                }else{
                    this.$notify.error({
                        title: '失败',
                        message: '图片添加失败'
                    });
                }
                console.log(this.form)
            },
            upload_error(err, file, fileList){
                console.log(err, file, fileList)
                this.form.picture=fileList
                this.$notify.error({
                    title: '失败',
                    message: '图片添加失败'
                });
            },
            remove_img(file, fileList){
                this.form.picture=fileList
                console.log(file, fileList)
            },
            // pickerOptions(){

            // },
            submitUpload(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.form.openid = this.token;
                        this.$axios.post('/api/upload_zgtz', this.form).then(res => {
                            if (res.data.code === '200ok') {
                                this.unit.rectification = res.data.rectification;
                                this.$message({
                                    message: '上传成功',
                                    type: 'success'
                                });
                                this.$refs[formName].resetFields();
                                this.form.picture = [];
                                this.dialogFormVisible = false
                            }else{
                                this.$message.error(res.data.msg)
                            }
                        })
                    } else{
                        this.$notify.error({
                            title: '失败',
                            message: '表单数据异常'
                        });
                    }
                });
            },
        },
    }
</script>